"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "usePrevious", {
    enumerable: true,
    get: ()=>usePrevious
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const usePrevious = (value)=>{
    const ref = _react.useRef(null);
    _react.useEffect(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}; //# sourceMappingURL=usePrevious.js.map

//# sourceMappingURL=usePrevious.js.map